export default "__VITE_ASSET__ZjqvhEmq__"